import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE_URL } from '../api';

export default function LoginPage() {
  const [loginVal, setLoginVal] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [mobileMsg, setMobileMsg] = useState('');
  // Shown when the user was bounced here by an expired session (apiFetch 401).
  const [infoMsg] = useState(() => {
    try {
      return new URLSearchParams(window.location.search).get('expired')
        ? "Sessiya muddati tugadi. Iltimos, qaytadan tizimga kiring."
        : '';
    } catch {
      return '';
    }
  });
  const [loading, setLoading] = useState(false);
  const { login: saveAuth } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMobileMsg('');

    if (!loginVal.trim() || !password.trim()) {
      setError("Login va parol bo'sh bo'lishi mumkin emas");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login: loginVal, password }),
      });

      let data = null;
      try {
        data = await res.json();
      } catch {}

      if (res.status === 401) {
        setError("Login yoki parol noto'g'ri");
        return;
      }

      if (!res.ok) {
        setError((data && data.message) || 'Xatolik yuz berdi');
        return;
      }

      const { token, role, user } = data || {};

      if (role === 'admin') {
        saveAuth(token, role, user);
        navigate('/admin', { replace: true });
      } else if (role === 'provider') {
        // Hizmat ko'rsatuvchi (usta) — provayder kabinetiga o'tadi.
        saveAuth(token, role, user);
        navigate('/provider/orders', { replace: true });
      } else {
        setMobileMsg('Mijozlar uchun mobil ilovadan foydalaning.');
      }
    } catch {
      setError("Tarmoq xatosi. Iltimos, qayta urinib ko'ring.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <img src="/brand-mark.png" alt="" style={s.logo} />
        <h1 style={s.title}>TezHal</h1>
        <p style={s.subtitle}>Tizimga kirish</p>

        {infoMsg && (
          <div style={s.infoBox} role="status">
            {infoMsg}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div style={s.field}>
            <label style={s.label} htmlFor="login-input">Login</label>
            <input
              id="login-input"
              type="text"
              value={loginVal}
              onChange={(e) => setLoginVal(e.target.value)}
              style={{ ...s.input, ...(loading ? s.inputDisabled : {}) }}
              placeholder="Loginni kiriting"
              disabled={loading}
              autoComplete="username"
              autoFocus
            />
          </div>

          <div style={s.field}>
            <label style={s.label} htmlFor="password-input">Parol</label>
            <input
              id="password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ ...s.input, ...(loading ? s.inputDisabled : {}) }}
              placeholder="Parolni kiriting"
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div style={s.errorBox} role="alert">
              {error}
            </div>
          )}

          {mobileMsg && (
            <div style={s.mobileBox} role="alert">
              <strong>Kirish taqiqlangan</strong>
              <br />
              {mobileMsg}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{ ...s.btn, ...(loading ? s.btnLoading : {}) }}
          >
            {loading ? 'Yuklanmoqda...' : 'Kirish'}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: '16px',
  },
  card: {
    background: 'var(--surface)',
    borderRadius: '16px',
    padding: '40px 36px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    textAlign: 'center',
  },
  logo: {
    // Haqiqiy brend belgisi (mobil ilova ikonkasi bilan bir xil).
    width: '58px',
    height: 'auto',
    display: 'block',
    margin: '0 auto 14px',
  },
  title: {
    margin: '0 0 4px',
    fontSize: '26px',
    fontWeight: '700',
    color: 'var(--text)',
  },
  subtitle: {
    margin: '0 0 28px',
    fontSize: '14px',
    color: 'var(--text-muted)',
  },
  field: {
    marginBottom: '16px',
    textAlign: 'left',
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    fontSize: '14px',
    fontWeight: '600',
    color: 'var(--text-secondary)',
  },
  input: {
    width: '100%',
    padding: '11px 14px',
    border: '1.5px solid #d1d5db',
    borderRadius: '8px',
    fontSize: '15px',
    color: 'var(--text)',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s',
    background: 'var(--surface)',
  },
  inputDisabled: {
    background: 'var(--bg)',
    color: 'var(--text-faint)',
    cursor: 'not-allowed',
  },
  errorBox: {
    background: 'var(--danger-tint)',
    border: '1px solid #fca5a5',
    borderRadius: '8px',
    padding: '10px 14px',
    marginBottom: '16px',
    fontSize: '14px',
    color: 'var(--danger)',
    textAlign: 'left',
  },
  mobileBox: {
    background: '#fffbeb',
    border: '1px solid #fcd34d',
    borderRadius: '8px',
    padding: '12px 14px',
    marginBottom: '16px',
    fontSize: '14px',
    color: '#92400e',
    textAlign: 'left',
    lineHeight: '1.5',
  },
  infoBox: {
    background: 'var(--info-tint)',
    border: '1px solid #bfdbfe',
    borderRadius: '8px',
    padding: '11px 14px',
    marginBottom: '18px',
    fontSize: '14px',
    color: '#1d4ed8',
    textAlign: 'left',
    lineHeight: '1.5',
  },
  btn: {
    width: '100%',
    padding: '12px',
    background: 'linear-gradient(135deg, #e94560, #c2254a)',
    color: 'var(--on-accent)',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
    marginTop: '4px',
  },
  btnLoading: {
    opacity: '0.65',
    cursor: 'not-allowed',
  },
};
